import React, { Component } from 'react';
import { Modal, Steps, Button, message } from 'antd';
const Step = Steps.Step;

class VisitTicketKindModal extends Component {
  constructor(props) {
    super(props);
    this.state = {step: 0, stepLimit: 0, validation: false, visitTicketKind: {}};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    // Input values
    this.handleName = this.handleName.bind(this);
    this.handleClave = this.handleClave.bind(this);
    this.setProp = this.setProp.bind(this);
  }

  handleNext() {
    if(!this.state.validation)
      return message.warning('Necesitas llenar los campos obligatorios')

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.visitTicketKind);
      this.setState({validation: true, visitTicketKind: {}});
    } else {
      this.setState({step: this.state.step + 1});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  handleName(event) {
    this.setProp('name', event.target.value);
    this.setState({validation: true});
  }

  handleClave(event) {
    this.setProp('clave', event.target.value);
    this.setState({validation: true});
  }

  setProp(prop, value) {
    const record = this.state.visitTicketKind;
    record[prop] = value;

    this.setState({visitTicketKind: record});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // Render component
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onCancel={this.props.handleClose}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Nombre" />
            <Step title="Finalizar" />
          </Steps>
        </div>

        <br/> <br/>

        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>Nombre</label>
              <input type="text" className="form-control" defaultValue={this.props.current.name} placeholder="Nombre de visitante" onChange={this.handleName} />
            </div>

            <div className="form-group">
              <label>Clave única</label>
              <input type="text" className="form-control" defaultValue={this.props.current.clave} placeholder="100" onChange={this.handleClave} />
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default VisitTicketKindModal;



// WEBPACK FOOTER //
// ./src/components/modals/VisitTicketKindModal.js